module.exports = __webpack_public_path__ + "static/media/registry.09a61540.png";